import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppSettings } from "../../../config/config";
import { apiConstants } from "../../constant/apiConstant";

export interface BusListItem {
  busId: number | string;
  busName: string;
  busNumber: string;
  busRouteName: string;
  busStartPointName: string;
  busEndPointName: string;
  startPointLatitude?: string | number;
  startPointLongitude?: string | number;
  endPointLatitude?: string | number;
  endPointLongitude?: string | number;
  driverName: string;
  driverProfileImage: string | null;
  driverMobileNumber: string;
  busInchargeName: string;
  busInchargeProfileImage: string | null;
  busInchargeMobileNumber: string;
}

export interface GetBusListResponse {
  status: boolean;
  message?: string;
  body?: {
    busList: BusListItem[];
  };
}

export interface BusStop {
  BusStopName: string;
}

export interface GetBusStopListResponse {
  status: boolean;
  message?: string;
  body?: {
    busStopList: BusStop[];
  };
}

export interface TransportStudent {
  studentFullName: string;
  parentName: string;
  classDivision: string;
  classNumber: string;
  mobileNumber: string;
  studentImageUrl?: string | null;
}

export interface GetStudentListForBusResponse {
  status: boolean;
  message?: string;
  body?: {
    studentList: TransportStudent[];
  };
}

export interface LatestVehicleLocationInfo {
  latitude: number | string;
  longitude: number | string;
  headingDirection: number;
  speed: number | string;
}

export interface GetVehicleLocationResponse {
  status: boolean;
  message?: string;
  body?: {
    latestVehicleLocationInfo: LatestVehicleLocationInfo;
  };
}

@Injectable({ providedIn: 'root' })
export class StaffTransportService {
  private url = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) {}

  getBusList(staffId: number | string, isSelfBusInchargeListFilterEnabled: boolean) {
    const params = new HttpParams()
      .set('lang', 'en')
      .set('staffId', String(staffId))
      .set('isSelfBusInchargeListFilterEnabled', String(isSelfBusInchargeListFilterEnabled));
    return this.http
      .get<GetBusListResponse>(this.url + apiConstants.getBusList, { params })
      .pipe(map((res) => res));
  }

  getBusStops(staffId: number | string, busId: number | string) {
    const params = new HttpParams()
      .set('lang', 'en')
      .set('staffId', String(staffId))
      .set('busId', String(busId));
    return this.http
      .get<GetBusStopListResponse>(this.url + apiConstants.getBusStopList, { params })
      .pipe(map((res) => res));
  }

  getStudentListForBus(staffId: number | string, busId: number | string) {
    const params = new HttpParams()
      .set('lang', 'en')
      .set('staffId', String(staffId))
      .set('busId', String(busId));
    return this.http
      .get<GetStudentListForBusResponse>(this.url + apiConstants.getStudentListForBus, { params })
      .pipe(map((res) => res));
  }

  getVehicleLocation(staffId: number | string, busId: number | string) {
    const params = new HttpParams()
      .set('lang', 'en')
      .set('staffId', String(staffId))
      .set('busId', String(busId));
    return this.http
      .get<GetVehicleLocationResponse>(this.url + apiConstants.getVehicleLocation, { params })
      .pipe(map((res) => res));
  }
}
